module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductsVisited":{"clear":"Smazat vše","heading":"Již jste prohlíželi","notifications":{"success":"Historie produktů smazána"}}},"en":{"ProductsVisited":{"clear":"Delete all","heading":"You have already viewed","notifications":{"success":"Product history deleted"}}}}')
  delete Component.options._Ctor
}
